import React, { useState } from 'react';
import DocViewer from '@cyntler/react-doc-viewer';
import { getFileNameFromAWSURL } from '../Utils/constantData';
import { notify } from '../Utils/toastify';

const FullScreenView = ({ doc, setIsFullView, isFullView, onClose }: any) => {
  const [zoom, setZoom] = useState<any>(1.1);
  const [rotation, setRotation] = useState(0);

  const handleZoomIn = () => setZoom(prev => Math.min(prev + 0.2, 3));
  const handleZoomOut = () => setZoom(prev => Math.max(prev - 0.2, 1));

  const handleRotate = () => setRotation(prev => (prev + 90) % 360);
  const toggleFullscreen = () => {
    setIsFullView(!isFullView);
  };

  const isImage = /\.(png|jpe?g|gif|webp)$/i.test(doc);
  const isPdf = /\.pdf$/i.test(doc);

  const handleDownload = (URL: string) => {
    fetch(URL)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.blob();
      })
      .then(blob => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = getFileNameFromAWSURL(URL);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(error => {
        notify('Unable to download the document.', 'error');
      });
  };

  return (
    <div className="doc-fullscreen">
      <div className="grey-heading title-flex mb-8">
        <h2 className="MuiTypography-body2 fw600 lh-16">Documents</h2>
        <div>
          {isPdf ? null : (
            <>
              <button
                title="full Screen"
                onClick={handleZoomIn}
                className="blank-btn"
              >
                <i className="zoom-in-icon"></i>
              </button>
              <button
                title="full Screen"
                onClick={handleZoomOut}
                className="blank-btn"
              >
                <i className="zoom-out-icon"></i>
              </button>
              <button
                title="full Screen"
                onClick={handleRotate}
                className="blank-btn"
              >
                <i className="rotate-icon"></i>
              </button>
            </>
          )}

          <button
            title="full Screen"
            onClick={toggleFullscreen}
            className="blank-btn"
          >
            <i className="full-screen-icon"></i>
          </button>
          <button
            title="full Screen"
            onClick={() => handleDownload(doc)}
            className="blank-btn"
          >
            <i className="download-icon"></i>
          </button>
          <button
            className="blank-btn close-doc "
            onClick={() => {
              setIsFullView(false);
              onClose(false);
            }}
          >
            <i className="cross-icon"></i>
          </button>
        </div>
      </div>

      <div className="doc-frame">
        <div
          className="doc-viewer-container"
          style={
            isImage
              ? {
                  ['--rotation' as any]: `${rotation}deg`,
                  ['--zoom' as any]: zoom,
                }
              : {}
          }
        >
          {doc ? (
            isPdf ? (
              <iframe
                src={doc}
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none',
                }}
                title="PDF Viewer"
              />
            ) : (
              <DocViewer
                documents={[{ uri: doc }]}
                config={{
                  header: { disableHeader: true, disableFileName: true },
                  pdfZoom: { defaultZoom: zoom, zoomJump: 0.2 },
                  pdfVerticalScrollByDefault: true,
                }}
                style={{ width: '100%', height: '100%' }}
              />
            )
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default FullScreenView;
